import { WiredTemperatureSensor } from 'z3k-config';
export function getWiredTemperatureSensor(config) {
    return WiredTemperatureSensor.get.where(config, WiredTemperatureSensor.isRealSensor);
}
